export default {
  seo: {
    title: 'Beaconly — Lightweight, private, real-time web analytics',
    description:
      'Cookie-free, banner-free web analytics. A 1KB script, live visitors, a one-screen dashboard and infinite history. GDPR-friendly.',
  },
  nav: {
    features: 'Features',
    how: 'How it works',
    pricing: 'Pricing',
    faq: 'FAQ',
    cta: 'Start free',
    menuLabel: 'Open menu',
    langLabel: 'Language',
  },
  hero: {
    eyebrow: 'No cookies · No banner · GDPR',
    titleA: 'Your site,',
    titleB: 'illuminated.',
    sub: 'Beaconly shows who visits, where they come from and what works — in real time, no cookies, no consent banner, no weight on your page. A 1 KB script. Installs in one minute.',
    ctaPrimary: 'Start free',
    ctaSecondary: 'See how it works',
    stats: {
      m1: { label: 'Script', value: '1 KB' },
      m2: { label: 'Event', value: '<10 ms' },
      m3: { label: 'Cookies', value: '0' },
    },
  },
  beacon: {
    live: 'Live',
    visitorsNow: 'Visitors now',
    pageviewsToday: 'Pageviews today',
    bounce: 'Bounce',
    duration: 'Avg. duration',
  },
  features: {
    eyebrow: 'Why Beaconly',
    title: 'All the analytics insight. None of the tracking.',
    items: {
      f1: {
        tag: 'Privacy',
        title: 'Privacy by design',
        body: 'Zero cookies, zero fingerprinting. Each visitor becomes a cryptographic hash that self-destructs every day — even with full database access, nobody can trace anyone across days.',
      },
      f2: {
        tag: 'Performance',
        title: 'A 1KB script',
        body: 'Async, dependency-free, weightless. Your page barely notices — and your Core Web Vitals thank you.',
      },
      f3: {
        tag: 'Real time',
        title: 'Truly live',
        body: 'The visitors-now badge updates in under 1 second, straight from our ingestion pipeline.',
      },
      f4: {
        tag: 'Simplicity',
        title: 'One-screen dashboard',
        body: 'Pages, sources, countries and devices without digging through 4 menus. Everything you need in 10 seconds.',
      },
      f5: {
        tag: 'History',
        title: 'Infinite history',
        body: 'Your numbers archived for you, in an open format. The dashboard merges years of data without losing speed.',
      },
      f6: {
        tag: 'Ownership',
        title: 'Your data, yours',
        body: 'Open-format export and a full API. Zero lock-in — if you ever leave, you take everything with you.',
      },
    },
  },
  how: {
    eyebrow: 'How it works',
    title: 'From snippet to insight in three steps.',
    steps: {
      s1: {
        title: 'Paste the script',
        body: 'Create a site in the app and copy one line of code. Paste it before </body> — there is no step two.',
        code: '<script defer src="https://beaconly.com/a.js" data-site="abc123"></script>',
      },
      s2: {
        title: 'Watch the traffic',
        body: 'Every visit becomes a number on your dashboard within seconds. Pages, sources, countries, devices, in real time.',
        code: '204 — received in <10ms',
      },
      s3: {
        title: 'Understand your audience',
        body: 'Find out which page converts, where the people who stay come from, and what changed this week vs last.',
        code: 'dashboard read: ~2ms',
      },
    },
  },
  pricing: {
    eyebrow: 'Pricing',
    title: 'Start free. Pay only for history.',
    sub: 'Until billing lands, everyone gets everything — no catch.',
    free: {
      name: 'Free',
      price: 'R$ 0',
      period: 'forever',
      cta: 'Start free',
      note: 'No credit card required.',
      features: {
        f1: 'Up to 10k pageviews/month',
        f2: '1 site',
        f3: '35-day retention',
        f4: 'Live visitors badge',
        f5: 'Full dashboard',
      },
    },
    pro: {
      name: 'Pro',
      price: 'R$ 29',
      period: '/mo',
      cta: 'Go Pro',
      note: 'Billing coming soon.',
      features: {
        f1: 'Up to 100k pageviews/month',
        f2: 'Unlimited sites',
        f3: 'Infinite history (S3)',
        f4: 'CSV export + full API',
        f5: 'Public dashboards',
        f6: 'Script on your own domain (CNAME)',
      },
    },
  },
  waitlist: {
    eyebrow: 'Launching soon',
    title: 'Join the waitlist.',
    sub: 'When Beaconly opens, you get an email with your access — before everyone else.',
    placeholder: "you{'@'}email.com",
    button: 'Join the waitlist',
    consent: 'I have read and agree to the',
    privacyLink: 'Privacy Policy',
    success: "You're on the list! We'll email you when we open.",
    errorInvalid: "That email doesn't look right.",
    errorServer: "Couldn't send it right now. Try again in a moment.",
    mono: 'No spam · One email when we launch',
  },
  faq: {
    eyebrow: 'FAQ',
    title: 'No silly questions. Just straight answers.',
    items: {
      q1: {
        q: 'Do I need a cookie banner on my site?',
        a: 'No. Beaconly uses no cookies and no fingerprinting, so there is nothing to consent to. You can delete the banner that existed only because of analytics — LGPD and GDPR stay covered without it.',
      },
      q2: {
        q: 'Does the script slow down my site?',
        a: 'The script is 1KB, async and non-blocking. Sending uses sendBeacon, which the browser does in the background. There is no comparison with the ~100KB of Google Analytics.',
      },
      q3: {
        q: 'Does it work with ad blockers?',
        a: 'Yes, better than traditional analytics: our domain is not on blocklists, and on Pro you can serve the script from your own domain (CNAME) — blocking drops to practically zero.',
      },
      q4: {
        q: 'How does privacy actually work?',
        a: 'Each visitor becomes a cryptographic hash that changes daily and is then destroyed. We store no raw IPs or User-Agents. Even with full database access, reconstructing who visited what is impossible.',
      },
      q5: {
        q: 'Can I export my data?',
        a: 'Yes, on Pro: CSV export, full API and open-format files. If you ever leave, you take everything — zero lock-in.',
      },
    },
  },
  footer: {
    tagline: 'Lightweight, private, real-time web analytics. Made in Brazil.',
    copyright: '© {year} Beaconly',
    mono: '0 cookies · 0 banners · 1KB',
    navLabel: 'Footer',
  },
};